import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BakeasySnackbarReduxProp } from '../../components/common/BakeasySnackBarRedux';
import { RootState } from '../reduxStore';
import { t } from 'i18next';

const initialState: BakeasySnackbarReduxProp = {
  open: false,
  message: '',
  severity: 'info'
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSuccessSnackbar(state, action: PayloadAction<BakeasySnackbarReduxProp>) {
      state.open = true;
      state.message = getMessage(action.payload.message);
      state.severity = 'success';
    },
    showErrorSnackbar(state, action: PayloadAction<BakeasySnackbarReduxProp>) {
      state.open = true;
      state.message = getMessage(action.payload.message);
      state.severity = 'error';
    },
    hideSnackbar(state) {
      state.open = false;
      state.message = '';
      state.severity = 'info';
    }
  }
});

function getMessage(err: any) {
  let message = '';
  if (err?.response?.data?.error) {
    message = JSON.stringify(err?.response?.data?.error);
  } else if (err?.response?.data) {
    message = JSON.stringify(err?.response?.data);
  } else if (err?.data) {
    message = JSON.stringify(err?.data);
  } else if (err?.message?.message) {
    message = JSON.stringify(err?.message?.message);
  } else if (err?.message) {
    message = JSON.stringify(err?.message);
  } else if (err?.error?.error) {
    message = JSON.stringify(err?.error?.error);
  } else if (err?.error?.message) {
    message = JSON.stringify(err?.error?.message);
  } else if (err?.error) {
    message = JSON.stringify(err?.error);
  } else {
    message = err;
  }

  return t(message);
}

export const snackbarState = (state: RootState) => state?.snackbar;
export const { hideSnackbar, showSuccessSnackbar, showErrorSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
